import React from 'react';
import MaterialTable from 'material-table';
import { collection, query,where } from 'firebase/firestore';
import { useFirestoreCollectionData} from 'reactfire';
import { useFirestore } from 'reactfire';
import {useNavigate } from 'react-router-dom';
import moment from 'moment';
import {CreateDialog} from './create-attendance';
import { Box } from '@material-ui/core';



export const AttendanceTable = ({group}:{group:number}) => {


  const db = useFirestore();
  const attendanceListsQuery = query(
    collection(db, 'attendanceLists'),
    where('group', '==', group));
  const { data } = useFirestoreCollectionData(attendanceListsQuery, {
    idField: 'id', // this field will be added to the object created from each document
  });

  const navigate = useNavigate();

  return (
    <Box mt={2}>
      <MaterialTable
        title="Attendance Management"
        columns={[
          { 
            title: 'Attendance date', 
            field: 'date', 
            initialEditValue: new Date(),
            type: 'date' as const ,
            render: rowData => {
              const date = rowData['date'];
              return `${date} (${moment(date,'DD-MM-YYYY').format('ddd')})`;
            }
          // editable:'onAdd'
          },
        ]}
        data={data}
        options={{
          paginationType:'stepped',
          actionsColumnIndex: -1
        }}
        onRowClick={(event, rowData) => { navigate(`/app/attendance/${rowData?.id??''}`);}}
        actions={[
          {
            icon: 'edit',
            tooltip: 'Save User',
            onClick: (event, rowData) => alert('You saved ')
          },
          {
            icon: 'add',
            tooltip: 'Add attendance',
            isFreeAction: true,
            onClick: (event) => { navigate('/app/attendance?create');}
          },
          rowData => ({
            icon: 'delete',
            tooltip: 'Delete User',
            onClick: (event, rowData) => confirm('You want to delete '),
            disabled: rowData.birthYear < 2000
          })
        ]}
      />
      <CreateDialog/>
    
    </Box>
  );
};


//https://codesandbox.io/s/hc0fw?file=/src/App.tsx